// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sfcNodeContainer[data-v-aff6e31e] {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
